import React, { Component } from "react";
import { Link } from "react-router-dom";
import AuthService from "../../utils/auth.service";
import MessageModal from "../../components/Message";
import Loading from "../../components/Loading";

//import Const from "../../utils/consts"

import ApiPagarmeCustomer from "../../utils/api.pagarme.customer";
import ApiRateio from "../../utils/api.rateio";

class CreditCardPage extends Component {
  constructor(props) {
    super(props);

    //let company_code = localStorage.getItem('company_code');
	  
    this.state = {
      profile: AuthService.profileUser,
      modal: {
        isOpen: false,
        title: '',
        message: '',
      },
      loading: false,
      cards: [],
    };

    this.handleElementChange = this.handleElementChange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    //this.renderCards = this.renderCards.bind(this);
	  
	  this.gotoPaymentPageV2 = this.gotoPaymentPageV2.bind(this);
	  this.convertCardV2 = this.convertCardV2.bind(this);
  }
  
  payment_gateway = 'RateioDigital';

  brands = {
    visa: '/assets/images/bandeira_visa_cor.svg',
    mastercard: '/assets/images/bandeira_mastercard_cor.svg',
    american: '/assets/images/bandeira_american_cor.svg',
    elo: '/assets/images/bandeira_elo_cor.svg',
  };

  componentDidMount() {
  	if (this.state.profile) {
  		this.getGatewayCards(this.payment_gateway, this.state.profile.email);
  		
	  }
	  
  }

  handleElementChange(event) {
    const el = event.target.name;
    const val = event.target.value;
    this.setState(...this.state, { [el]: val });
  }

  handleBack() {
    this.props.history.goBack();
  }
  
  getGatewayCards = (gateway, email) => {
	  
  	switch (gateway) {
		  
		  case 'PagarMe': {
		  	this.getCardsV1(email);
			  break;
		  }
		  
		  case 'RateioDigital': {
		  	this.getCardsV2(email);
		  	break;
		  }
		  
		  default: {
		  	console.log('Nem Rateio, Nem Pagarme????')
		  }
	  }
	  
  };
  
  renderCardsDeprecated(cards) {
	  
  	//if (!cards.length) {
		//  this.props.history.push('/profile/payment');
		//  return;
    // }
  	
    //let list = cards.map((card) =>
    
    //  <li className='creditcard-item' onClick={() => this.gotoPaymentPage(card)} key={card.id}>
    //    <div className="row d-flex align-items-center m-3 p-3">
    //      <div className="col-12">
    //        <div className="number-card">XXXX - XXXX - XXXX - {card.last_digits}</div>
    //        <div className="name-card">{card.holder_name}</div>
    //      </div>
    //    </div>
	  //  <div className="row">
    //      <div className="offset-8 col">
    //        <img src={this.brands[card.brand]} alt="" className="img-card" />
    //      </div>
    //    </div>
    //  </li>);
  	
    //this.setState({ cards: list });
  	
  };
	
  //#region PagarMe
	
	getCardsV1(email) { // get modificado sem api_key
    const pagarme = require('pagarme');
    let list = [];
    pagarme.client.connect({ api_key: 'ak_test_8VShIWqrXoOPGNpEi3DnGTum9WHAqz' })
      .then(client => {
        ApiPagarmeCustomer.get(email).then((response) => {
          //const hits = response.data.hits.hits;
          const customer_id = response.data ? response.data.hits.hits.length ? response.data.hits.hits[0]._id : 0 : 0;
          client.cards.find({ customer_id: customer_id }).then((cards) => {
            if (!cards.length) {
              this.props.history.push('/profile/payment');
              return;
            }
            list = cards.map((card) =>
              <li className='creditcard-item' onClick={() => this.gotoPaymentPageV1(card)} key={card.id}>
                <div className="row d-flex align-items-center m-3 p-3">
                  <div className="col-12">
                    <div className="number-card">XXXX - XXXX - XXXX - {card.last_digits}</div>
                    <div className="name-card">{card.holder_name}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="offset-8 col">
                    <img src={this.brands[card.brand]} className="img-card" alt="" />
                  </div>
                </div>
              </li>);
            this.setState({ cards: list });
          });
        });
      });
  };
	
  getCardsDeprecatedV1(email) {
    const pagarme = require('pagarme');
    let list = [];
    
    pagarme.client.connect({ api_key: 'ak_test_8VShIWqrXoOPGNpEi3DnGTum9WHAqz' })
      .then(client => {
        return ApiPagarmeCustomer.get(email).then((response) => {
          //const hits = response.data.hits.hits;
          const customer_id = response.data ? response.data.hits.hits.length ? response.data.hits.hits[0]._id : 0 : 0;
          client.cards.find({ customer_id: customer_id }).then((cards) => {
           
          	if (!cards.length) {
              this.props.history.push('/profile/payment');
              return;
            }
	          
	          console.log('**** cards:', cards);
            
            list = cards.map((card) =>
              <li className='creditcard-item' onClick={() => this.gotoPaymentPage(card)} key={card.id}>
                <div className="row d-flex align-items-center m-3 p-3">
                  <div className="col-12">
                    <div className="number-card">XXXX - XXXX - XXXX - {card.last_digits}</div>
                    <div className="name-card">{card.holder_name}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="offset-8 col">
                    <img src={this.brands[card.brand]} alt="" className="img-card" />
                  </div>
                </div>
              </li>);
            this.setState({ cards: list });
          });
        });
      });
  };
  
  gotoPaymentPageV1(card) {
	  
    this.props.history.push({
      pathname: '/profile/payment',
	    state: {
        id: card.card_id,
        brand: card.brand,
        holder_name: card.card_holder_name, // card_holderName???
        //first_digits: card.attributes.first_digits,
        last_digits: card.last_digits,
        
        expiration_month: card.expiration_date.slice(0,1),
		    expiration_year: card.expiration_date.slice(2,3)
      }
    });
  }
  
  //#endregion PagarMe
  
  //#region RateioDigital
	
	getCardsV2(email) {
    
    let list = [];
    let user_list = [];
    let cards_list = [];
    
    //debugger;
    try {
	    ApiRateio.getUserList(email)
		    .then(response => {
		
			    user_list = response.data.data ? response.data.data : [];
			    
			    if (!user_list || !user_list.length ) {
				    this.props.history.push('/profile/payment'); // 'profile/paymentuser'
				    //console.log('No user list: Go to pay page with no card ');
				    //this.gotoPaymentPageV2(this.payment_gateway, null);
				    return;
			    }
			
			    ApiRateio.getCards(user_list[0].id)
				    .then(response => {
				    
					    cards_list = response.data.data;
					    
					    //console.log('ApiRateio.getCards cards_list:', cards_list);
					    
					    if (!cards_list || !cards_list.length ) {
						    this.props.history.push('/profile/payment');
						    //console.log('No card list: Go to pay page with no card ')
						    //this.gotoPaymentPageV2(this.payment_gateway, null);
						    return;
					    }
					    
					    //console.log('Cards List ', cards_list);
					    
					    list = cards_list.map(card =>
						    <li className='creditcard-item' key={card.id}>
							    
							    <Link to={{pathname: "/profile/payment",
								              state: this.convertCardV2(this.payment_gateway, card)}}>
								    
								    <div className="row">
									    <div className="offset-11 col">
										      <img src="/assets/images/delete_image.jpeg"
										           onClick={() => this.removeCardV2(user_list[0].id, card.id)}
										           alt="" width="20" height="20"/>
									    </div>
								    </div>
								    
								    <div className="row d-flex align-items-center m-3 p-3">
									    <div className="col-12">
										    <div className="number-card">XXXX - XXXX - XXXX - {card.attributes.last_digits}</div>
										    <div className="name-card">{card.attributes.holder_name}</div>
									    </div>
								    </div>
								    
								    <div className="row">
									    {card.attributes.card_brand}
									    <div className="offset-8 col">
										    
										    <img src={this.brands[card.attributes.card_brand]} className="img-card" alt=""/>
									    </div>
									    
								    </div>
						      </Link>
					      </li>);
					    this.setState({cards: list});
					    //});
			    }); //todo: Colocar catch ????
	    })
		    .catch((response) => {
	    	  console.log('Probably User not logged.... No cards today...')
		      console.log(response.errors);
	    });
    } catch (error) {
	    this.setState({
		    modal: {
			    title: 'Oops!', message: 'an error has occurred', isOpen: true,
		    }
	    });
    }
  };
  
  convertCardV2(gateway, card) {
  	
  	const cardV2 = {
  		
  		id: card.id,
      brand: card.attributes.card_brand,
      holder_name: card.attributes.holder_name,
      
      last_digits: card.attributes.last_digits,
      
	    expiration_month: card.attributes.expiration_month,
	    expiration_year: card.attributes.expiration_year,
	    
	    gateway: gateway
  		
	  };
  	
  	return cardV2;
  }
  
  gotoPaymentPageV2(gateway, card) {
	
	  if (card) {
	  	
	  	let state_card = null;
	  	
		  switch (gateway) {
		   
			  case 'PagarMe': {
			  	
			  	state_card = {
			  		
			  		id: card.card_id,
		        brand: card.brand,
		        holder_name: card.card_holder_name, // card_holderName???
		        //first_digits: card.attributes.first_digits,
		        last_digits: card.last_digits,
		        
		        expiration_month: card.expiration_date.slice(0,1),
				    expiration_year: card.expiration_date.slice(2,3),
		    
				  };
			    break;
			  }
			  
			  case 'RateioDigital': {
			    
			    state_card = {
			    	
			    	id: card.id,
		        brand: card.attributes.card_brand,
		        holder_name: card.attributes.holder_name,
		        
		        last_digits: card.attributes.last_digits,
		        
				    expiration_month: card.attributes.expiration_month,
				    expiration_year: card.attributes.expiration_year,
				    
				    gateway: gateway
			     
				  };
			    console.log('Go to Payment with card', state_card)
				  break;
			  }
			  
			  default: {
			    console.log('Nem um nem outro...')
			  }
		  }
		  
		  console.log('Push com state_card', state_card);
		  
		  this.props.history.push({
			  pathname: '/profile/payment ',
			  state: state_card
		  });
		  
	  } else {
	  	
	  	console.log('Push sem state_card');
		
		  this.props.history.push({
			  pathname: '/profile/payment '
		  });
	  }
  }
  
  gotoPaymentWithCard(card) {
  	
  	const gateway = this.payment_gateway;
	
	  if (card) {
	  	
	  	let state_card = null;
	  	
		  switch (gateway) {
		   
			  case 'PagarMe': {
			  	
			  	state_card = {
			  		
			  		id: card.card_id,
		        brand: card.brand,
		        holder_name: card.card_holder_name, // card_holderName???
		        //first_digits: card.attributes.first_digits,
		        last_digits: card.last_digits,
		        
		        expiration_month: card.expiration_date.slice(0,1),
				    expiration_year: card.expiration_date.slice(2,3),
		    
				  };
			    break;
			  }
			  
			  case 'RateioDigital': {
			    
			    state_card = {
			    	
			    	id: card.id,
		        brand: card.attributes.card_brand,
		        holder_name: card.attributes.holder_name,
		        
		        last_digits: card.attributes.last_digits,
		        
				    expiration_month: card.attributes.expiration_month,
				    expiration_year: card.attributes.expiration_year,
				    
				    gateway: gateway
			     
				  };
			    console.log('Go to Payment with card', state_card)
				  break;
			  }
			  
			  default: {
			    console.log('Nem um nem outro...')
			  }
		  }
		  
		  console.log('Push com state_card', state_card);
		  
		  this.props.history.push({
			  pathname: '/profile/payment ',
			  state: state_card
		  });
		  
	  } else {
	  	
	  	console.log('Push sem state_card');
		
		  this.props.history.push({
			  pathname: '/profile/payment '
		  });
	  }
  }
	
  removeCardV2(userId, cardId) {
  	//window.alert('Remover Cartao ?');
  	
  	//userId = 'd06e7178-4bad-4597-9cb4-9ad1d51ffa7a';
  	//userId = 'd8b730fd-ee05-4daf-93d1-77e107b89160';
  	
  	ApiRateio.removeCard(userId, cardId)
		  .then(response => {
		  	//console.log('Remove Card response:', response);
		  	//console.log('Remove Card push creditcards (no state)');
			  
			  this.setState({
			    modal: {
				    title: 'Yes!!!', message: 'Cartao removido...', isOpen: true,
			    }
	      });
			  this.props.history.push('/profile/creditcards');
	  })
		  .catch(error => {
  		  //console.log(error.data);
  		  this.setState({
			    modal: {
				    title: 'Opps...', message: 'Erro: Cartao nao removido...', isOpen: true,
			    }
	      });
	    });
	  
  };
  
  //#endregion
	
	toggleAlert() {
    this.setState(...this.state, {
      modal: { isOpen: !this.state.modal.isOpen }
    });
  }
	
  render() {
    return (
      <section className="profile-page">
        <div className="container">
          <div className="row payment-main">
            <div className="col-md-8 payment-inner-div">
              <ul className="creditcard-list">
                {this.state.cards}
              </ul>
            </div>
          </div>

          <div className="row justify-content-center">
	          
            <div className="col-md-8">
              <div className="col-3 float-center">
                <Link to="/profile/wallet"
                  className="btn btn-outline-secondary float-left">
                  Voltar
                </Link>
              </div>
              <div className="col-8 float-right">
	              <Link to="/profile/payment"
                  className="btn btn-outline-success float-right">
                  Incluir novo cartão
                </Link>
	              {/*<button className="btn btn-outline-success float-left"
                        onClick={() => this.gotoPaymentPageV2(this.payment_gateway, null)}>
	                Incluir cartao
                </button>*/}
              </div>
            </div>
	          
            <p className="col-8 float-center">
	            <hr />
	            Clique no cartão cadastrado para depositar
	            ou inclua um novo cartão.
            </p>
	           
          </div>

          <Loading active={this.state.loading} />
          <MessageModal
            isOpen={this.state.modal.isOpen}
            toggle={this.toggleAlert}
            title={this.state.modal.title}
            message={this.state.modal.message}
          />
        </div>
      </section>
    );
  }
}

export default CreditCardPage;



// WEBPACK FOOTER //
// ./src/containers/CreditCardPage/index.js